// eslint-disable-next-line import/prefer-default-export
export const CHECKOUT_VARIANTS = {
  regular: 'checkout',
  instabook: 'instabook checkout',
};

export const PARAM_CHECKOUT_INSTABOOK_GUEST_ERROR = 'instabook_guest_error';
